import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  IELAsyncAutocompleteElement,
  SELECTION_MODE,
} from '@el-async-autocomplete';
import { TranslateService } from '@ngx-translate/core';

import { IAssign, IInvitees } from '@shared/interfaces';

import { noWhitespaceValidator } from '../../../core/helpers/form-field-white-space-validator';
import { IdentitiesService } from '../../../identities/services/identities.service';
import { IFilterData } from '../../../setup/messages/popups/add-new-message-group/add-new-group.component';
@Component({
  selector: 'app-asset-allocate',
  templateUrl: './asset-allocate.component.html',
  styleUrls: ['./asset-allocate.component.scss'],
})
export class AssetAllocateComponent implements OnInit {
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;
  autoComplete: MatAutocompleteTrigger;
  SELECTION_MODE = SELECTION_MODE;

  constructor(
    public dialogRef: MatDialogRef<AssetAllocateComponent>,
    @Inject(MAT_DIALOG_DATA)
    protected data,
    public translate: TranslateService,
    private identitiesService: IdentitiesService
  ) {}

  AssignAssetForm: FormGroup<{
    lend_on_date: FormControl<Date>;
    return_on_date: FormControl<Date>;
    lend_to: FormControl<string>;
  }>;

  assignee: IELAsyncAutocompleteElement[] = [];
  filteredInvitees: IInvitees[] = [];
  public selectedUsers: IELAsyncAutocompleteElement;
  isAssignee = false;
  selectable = true;
  isView = false;
  isUpdate = false;
  isListLoading = true;
  todayDate = new Date();
  minDate = new Date();
  loggedUserData: any;

  ngOnInit(): void {
    this.setFormData();
    this.AssignAssetForm.get('lend_to');
    this.AssignAssetForm.get('lend_on_date');
    this.AssignAssetForm.get('return_on_date');
    const asset = this.data.assign_asset;
    if (asset.length > 0) {
      this.minDate = new Date(asset[asset.length - 1].return_on_date);
    } else {
      this.minDate = new Date(this.data?.purchase_date);
    }
  }
  setFormData() {
    this.AssignAssetForm = new FormGroup({
      lend_to: new FormControl(null, noWhitespaceValidator),
      lend_on_date: new FormControl(null),
      return_on_date: new FormControl(null),
    });
  }

  selectUser(e) {
    this.filteredInvitees = e.key;
  }

  onFilterUsers(eventData: IFilterData) {
    if (eventData.type === 'scroll') {
      let httpParams = new HttpParams();
      httpParams = httpParams.append('name', eventData.event);
      httpParams = httpParams.append('start', eventData.start);
      httpParams = httpParams.append('size', eventData.size);
      this.identitiesService
        .getIdentitiesWithoutContactPerson(httpParams)
        .subscribe((data_all_users) => {
          const filterUserList = [];
          data_all_users.data.forEach((user) => {
            filterUserList.push({
              key: user._id,
              value: `${user?.first_name} ${
                user?.last_name ? user?.last_name : ''
              } `,
            });
          });

          this.assignee = this.assignee.concat(filterUserList);
        });
    } else if (eventData.type === 'typing') {
      let httpParams = new HttpParams();
      httpParams = httpParams.append('name', eventData.event);
      httpParams = httpParams.append('start', eventData.start);
      httpParams = httpParams.append('size', eventData.size);
      this.identitiesService
        .getIdentitiesWithoutContactPerson(httpParams)
        .subscribe((data_all_users) => {
          const filterUserList = [];
          data_all_users.data.forEach((user) => {
            filterUserList.push({
              key: user._id,
              value: `${user?.first_name} ${
                user?.last_name ? user?.last_name : ''
              } `,
            });
          });

          this.assignee = filterUserList;
        });
    } else this.dialogRef.close();
  }

  onAssign(): void {
    if (this.AssignAssetForm.invalid) return;
    if (this.AssignAssetForm.valid) {
      const lendToValue = this.filteredInvitees.toString();

      if (lendToValue === null) {
        return;
      }

      const project: IAssign = {
        ...this.data,
        lend_to: this.filteredInvitees,
        lend_on_date: this.AssignAssetForm.get('lend_on_date').value,
        return_on_date: this.AssignAssetForm.get('return_on_date')?.value,
        remarks: '',
        _id: '',
      };

      this.dialogRef.close(project);
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
